export function zip (s) {
    try {
      var dict = {}
      var data = (s + '').split('')
      var out = []
      var currChar
      var phrase = data[0]
      var code = 256
      for (var i = 1; i < data.length; i++) {
        currChar = data[i]
        if (dict[phrase + currChar] != null) {
          phrase += currChar
        } else {
          out.push(phrase.length > 1 ? dict[phrase] : phrase.charCodeAt(0))
          dict[phrase + currChar] = code
          code++
          phrase = currChar
        }
      }
      out.push(phrase.length > 1 ? dict[phrase] : phrase.charCodeAt(0))
      for (var j = 0; j < out.length; j++) {
        out[j] = String.fromCharCode(out[j])
      }
      return utoa(out.join(''))
    } catch (e) {
      console.log('Failed to zip string return empty string', e)
      return ''
    }
  }
  
  // Decompress an LZW-encoded base64 string
export function unzip (base64ZippedString) {
    try {
      var s = atou(base64ZippedString)
      var dict = {}
      var data = (s + '').split('')
      var currChar = data[0]
      var oldPhrase = currChar
      var out = [currChar]
      var code = 256
      var phrase
      for (var i = 1; i < data.length; i++) {
        var currCode = data[i].charCodeAt(0)
        if (currCode < 256) {
          phrase = data[i]
        } else {
          phrase = dict[currCode] ? dict[currCode] : oldPhrase + currChar
        }
        out.push(phrase)
        currChar = phrase.charAt(0)
        dict[code] = oldPhrase + currChar
        code++
        oldPhrase = phrase
      }
      return out.join('')
    } catch (e) {
      console.log('Failed to unzip string return empty string', e)
      return ''
    }
  }
  
  // ucs-2 string to base64 encoded ascii
  function utoa (str) {
    return window.btoa(unescape(encodeURIComponent(str)))
  }
  // base64 encoded ascii to ucs-2 string
  function atou (str) {
    return decodeURIComponent(escape(window.atob(str)))
  }

  export function lzw_encode(s) {
    if (!s) return s;
    var dict = new Map(); // Use a Map!
    var data = (s + "").split("");
    var out = [];
    var currChar;
    var phrase = data[0];
    var code = 256;
    for (var i = 1; i < data.length; i++) {
        currChar = data[i];
        if (dict.has(phrase + currChar)) {
            phrase += currChar;
        } else {
            out.push(phrase.length > 1 ? dict.get(phrase) : phrase.charCodeAt(0));
            dict.set(phrase + currChar, code);
            code++;
            phrase = currChar;
        }
    }
    out.push(phrase.length > 1 ? dict.get(phrase) : phrase.charCodeAt(0));
    for (var i = 0; i < out.length; i++) {
        out[i] = String.fromCharCode(out[i]);
    }
    return out.join("");
}

export function lzw_decode(s) {
    var dict = new Map(); // Use a Map!
    var data = (s + "").split("");
    var currChar = data[0];
    var oldPhrase = currChar;
    var out = [currChar];
    var code = 256;
    var phrase;
    for (var i = 1; i < data.length; i++) {
        var currCode = data[i].charCodeAt(0);
        if (currCode < 256) {
            phrase = data[i];
        } else {
            phrase = dict.has(currCode) ? dict.get(currCode) : (oldPhrase + currChar);
        }
        out.push(phrase);
        currChar = phrase.charAt(0);
        dict.set(code, oldPhrase + currChar);
        code++;
        oldPhrase = phrase;
    }
    return out.join("");
}


async function compress (string, encoding = 'gzip') {
    const byteArray = new TextEncoder().encode(string)
    const cs = new CompressionStream(encoding)
    const writer = cs.writable.getWriter()
    writer.write(byteArray)
    writer.close()
    const buffer = await new Response(cs.readable).arrayBuffer()
    return btoa(String.fromCharCode.apply(null, new Uint8Array(buffer)))
  }
  
 async function decompress (data, encoding = 'gzip') {
    const cs = new DecompressionStream(encoding)
    const writer = cs.writable.getWriter()
    const byteArray = new Uint8Array([...atob(data)].map(char => char.charCodeAt(0)))
    writer.write(byteArray)
    writer.close()
    const arrayBuffer = await new Response(cs.readable).arrayBuffer()
    return new TextDecoder().decode(arrayBuffer)
  }
  
 export async function compressToURI(string, encoding = 'gzip') {
      const data = await compress(string, encoding)
      return encodeURIComponent(data)
    }


export async function decompressFromURI(string, encoding = 'gzip') {
      const data = decodeURIComponent(string)
      return await decompress(data, encoding)
    }
  